module.exports = __webpack_public_path__ + "840e3308faa0b1e17915a2e1198f6c4e.png";